export const MuiButton = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      whiteSpace: 'nowrap',
    },
  },
};
